import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_END_POINTS } from '@app/constant/api.constant';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InvestpackService {
  
  private filter: BehaviorSubject<InvestPackFilter> = new BehaviorSubject<InvestPackFilter>(null)
  private layoutSetting = new BehaviorSubject<any>({
    showHeader: true,
    showFooter: true,
  });
  private backLoaction: BehaviorSubject<string> = new BehaviorSubject<string>(null)
  
  private rebalanceInstrument: BehaviorSubject<any> = new BehaviorSubject<any>(null)
  
  constructor(
    private http: HttpClient
  ) { }

  investpackByID(id): Observable<any> {
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.portfolio}/${id}`);
  }

  investpackGraph(id: any, duration: any = 'live'): Observable<any> {
    return this.http.get(
      `${API_END_POINTS.INVESTOR_LONGTERM.investPack_graph}/${id}?duration=${duration}`
    );
  }

  getAllInvestPackChat(query: any): Observable<any> {
    return this.http.get(`${API_END_POINTS.CHAT.investPackChat}?${query}`);
  }

  topNews(id): Observable<any> {
    return this.http.get(
      `${API_END_POINTS.INVESTOR_LONGTERM.topNews}/${id}`
    );
  }

  subscribedInvestpackById(id): Observable<any> {
    return this.http.get(
      `${API_END_POINTS.INVESTOR_LONGTERM.subscribe}/wealthcase?wealthcaseId=${id}`
    );
  }

  getMissedProfit(id: any) {
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.missed_profit}/${id}`);
  }

  subscribePlan(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.INVESTOR_LONGTERM.subscribe, data);
  }

  renewPlan(data: any): Observable<any> {
    return this.http.put(API_END_POINTS.INVESTOR_LONGTERM.subscribe, data);
  }

  calculateInvestment(id: string, data: any): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.INVESTOR_LONGTERM.calculation}/${id}`,
      data
    );
  }

  addMoneyToWallet(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.WALLET.addAmount, data);
  }

  updateWalletTransaction(id: string, data: any): Observable<any> {
    return this.http.put(`${API_END_POINTS.WALLET.addAmount}/${id}`, data);
  }

  createExternalOrders(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.INVESTOR_LONGTERM.extrnal_orders, data);
  }

  investmentDetails(subscriptionId: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.investment_details}?subscriptionId=${subscriptionId}`)
  }

  reabalanceCalculation(subscriptionId: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.rebalance_details}/${subscriptionId}`)
  }

  rebalanceInstruments(data): Observable<any> {
    return this.http.post(API_END_POINTS.INVESTOR_LONGTERM.rebalance, data);
  }

  alreadyRebalanced(data): Observable<any> {
    return this.http.post(`${API_END_POINTS.INVESTOR_LONGTERM.external_rebalanc}`, data)
  }

  updateBrokerage(data) {
    return this.http.put(`${API_END_POINTS.INVESTOR.brokerage}`, data);
  }

  createInvestment(data): Observable<any> {
    return this.http.post(API_END_POINTS.INVESTOR_LONGTERM.invest, data);
  }

  getOrderStatus(orders: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.INVESTOR_LONGTERM.order_status}`, orders)
  }

  investPackMFORder(orderID): Observable<any> {
    return this.http.get(`${API_END_POINTS.MUTUALFUND.packOrder}/${orderID}`);
  }

  mfPaymentGate(data): Observable<any> {
    return this.http.post(API_END_POINTS.MUTUALFUND.payments, data);
  }

  mfupiPayment(data): Observable<any> {
    return this.http.post(`${API_END_POINTS.BSE.upi_payment}`, data)
  }

  mfSchemeImages(): Observable<any> {
    return this.http.get(API_END_POINTS.MUTUALFUND.amc);
  }

  sendInvestToWA(data): Observable<any> {
    return this.http.post(API_END_POINTS.INVESTOR_LONGTERM.send_to_whatsapp, data)
  }

  similarPortfolios(query): Observable<any> {
    return this.http.get(
      `${API_END_POINTS.INVESTOR_LONGTERM.portfolio}?${query}`
    );
  }
  setFilter(filter: InvestPackFilter) {
    this.filter.next(filter)
  }
  getFilter(): Observable<any> {
    return this.filter.asObservable()
  }

  getAllTags(query): Observable<any> {
    return this.http.get(
      `${API_END_POINTS.INVESTOR_LONGTERM.tags}?${query}`
    );
  }

  rebalanceAlert(): Observable<any> {
    return this.http.get(API_END_POINTS.INVESTOR_LONGTERM.dashboard_rebalance);
  }

  allSpecificPortfolios(query): Observable<any> {
    return this.http.get(
      `${API_END_POINTS.INVESTOR_LONGTERM.portfolio}?${query}`
    );
  }

  subscribedPortfolio(query?: string): Observable<any> {
    if (query) {
      return this.http.get(
        `${API_END_POINTS.INVESTOR_LONGTERM.subscribe}?${query}`
      );
    } else {
      return this.http.get(
        `${API_END_POINTS.INVESTOR_LONGTERM.subscribe}`
      );
    }
  }

  updateSip(id, data): Observable<any> {
    return this.http.put(`${API_END_POINTS.INVESTOR_LONGTERM.sip}/${id}`, data);
  }

  setInvestmentLayout(showHeader: boolean = true, showFooter: boolean = true) {
    this.layoutSetting.next({ showHeader, showFooter })
  }

  getInvestmentLayout(): Observable<{ showHeader, showFooter }> {
    return this.layoutSetting.asObservable()
  }

  holdings(query?): Observable<any> {
    if (query) {
      return this.http.get(
        `${API_END_POINTS.INVESTOR_LONGTERM.holdings}?${query}`
      );
    } else {
      return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.holdings}`);
    }
  }

  holdingsById(id: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.holdings}/${id}`);
  }

  subscribedFilterList(): Observable<any> {
    return this.http.get(API_END_POINTS.INVESTOR_LONGTERM.holdingsFilter)
  }

  dashboardStats(id?): Observable<any> {
    if (id) {
      return this.http.get(
        `${API_END_POINTS.INVESTOR_LONGTERM.dashboard_stats}/${id}`
      );
    } else {
      return this.http.get(API_END_POINTS.INVESTOR_LONGTERM.dashboard_stats);
    }
  }

  subscriptionById(id: string): Observable<any> {
    return this.http.get(
      `${API_END_POINTS.INVESTOR_LONGTERM.subscribe}/${id}`
    );
  }

  getTransactionData(query?): Observable<any> {
    if (query) {
      return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.holding_transactions}?${query}`)
    } else {
      return this.http.get(API_END_POINTS.INVESTOR_LONGTERM.holding_transactions)
    }
  }

  editOrDeleteTransaction(data): Observable<any> {
    return this.http.put(API_END_POINTS.INVESTOR_LONGTERM.holding_transactions, data)
  }

  editOrDeleteExternalOrders(data): Observable<any> {
    return this.http.put(API_END_POINTS.INVESTOR_LONGTERM.extrnal_orders, data);
  }

  searchInstruments(tradingSymbol: string): Observable<any> {
    let data = {
      search: tradingSymbol
    }
    return this.http.post(API_END_POINTS.INVESTOR_LONGTERM.dash_search, data)
  }
  investpackReviews(id: any, query: any) {
    return this.http.get(
      `${API_END_POINTS.INVESTOR_LONGTERM.ratingReview}/${id}?${query}`
    );
  }
  rateInvestPack(id: any, data: any) {
    return this.http.put(`${API_END_POINTS.INVESTOR_LONGTERM.rating}/${id}`, data);
  }
  getInvestpackRating(id: any) {
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.rating}/${id}`)
  }
  unSubscribedPorfolioById(id: any): Observable<any> {
    return this.http.get(
      `${API_END_POINTS.INVESTOR_LONGTERM.unSubscribe}/${id}`
    );
  }

  marketHours(): Observable<any> {
    return this.http.get(API_END_POINTS.AUTH.market_time)
  }

  allPortfolios(query): Observable<any> {
    return this.http.get(
      `${API_END_POINTS.INVESTOR_LONGTERM.all_investpack}?${query}`
    );
  }
  getInvestpacksWithSubs(): Observable<any> {
    return this.http.get(API_END_POINTS.INVESTOR_LONGTERM.investpacks_subscriptions)
  }
  getAdvisorList(query): Observable<any> {
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.advisor_list}?${query}`);
  }

  paymentSuccess(paymentData: {
    razorpay_payment_id: string,
    razorpay_order_id: string,
    razorpay_signature: string
  }): Observable<any> {
    return this.http.post(API_END_POINTS.PAYMENT_GATEWAY.verfiy_payment, paymentData)
  }

  paymentFailed(paymentData: any): Observable<any> {
    return this.http.post(API_END_POINTS.PAYMENT_GATEWAY.failed_payment, paymentData)
  }

  checkIfRiskMatching(investpackRisk: string) {
    let user = JSON.parse(window.localStorage.getItem('userProfile'))
    if (user.riskValue === 'conservative' && (investpackRisk === 'moderate' || investpackRisk === 'aggressive')) {
      return false
    } else if (user?.riskValue === 'moderate' && investpackRisk === 'aggressive') {
      return false
    } else {
      return true
    }
  }
  getPopupBanner() {
    return this.http.get(API_END_POINTS.POPUP_BANNER.popup_banner)
  }

  advisorDetail(id: any) {
    return this.http.get(`${API_END_POINTS.CLIENTS.advisors}/${id}`);
  }

  clientInvestpacks(query: string, id?: string) {
    return this.http.get(`${API_END_POINTS.CLIENTS.investpacks}?${query}`)
  }

  updateInvestpackAgreement(subscriptionID: string, agreementId: string): Observable<any> {
    return this.http.put(`${API_END_POINTS.INVESTOR_LONGTERM.update_investpack_agreement}/${subscriptionID}`, { agreement: agreementId })
  }

  transactionStatus(transactionID: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.TRANSACTIONS.transaction_status}?transactionId=${transactionID}`)
  }

  getAumSubscriptionDetail(investpackId: string) {
    return this.http.get(`${API_END_POINTS.AUM_BILLING.bill_info}/${investpackId}`)
  }

  getAumBillDetails(investpackId: string) {
    return this.http.get(`${API_END_POINTS.AUM_BILLING.bill_detail}/${investpackId}`)
  }

  getAumMonthlyBill(investpackId: string, year: number, month: number) {
    return this.http.get(`${API_END_POINTS.AUM_BILLING.monthly_bill}/${investpackId}?year=${year}&month=${month}`)
  }

  getAumUnsettledBill(investpackId: string, year: number, month: number) {
    return this.http.get(`${API_END_POINTS.AUM_BILLING.unsettled_bill}/${investpackId}?year=${year}&month=${month}`)
  }

  aumRebalanceCalculation(data): Observable<any> {
    return this.http.post(`${API_END_POINTS.INVESTOR_LONGTERM.aum_rebalance_calculation}`, data);
  }

  rebalanceAumInstruments(data): Observable<any> {
    return this.http.post(API_END_POINTS.INVESTOR_LONGTERM.aum_rebalance, data);
  }

  setBackLocation(backLocation) {
    this.backLoaction.next(backLocation)
  }

  getBackLocation(): Observable<any> {
    return this.backLoaction.asObservable()
  }
  advisorInfoDetail(id: any) {
    return this.http.get(`${API_END_POINTS.CLIENTS.advisorInfo}/${id}`);
  }
  advisorTopThreePack(id: any) {
    return this.http.get(`${API_END_POINTS.CLIENTS.advisorTopThreePack}/${id}`);
  }
  advisorComplaindDetail(id: any, complaints: any) {
    return this.http.get(`${API_END_POINTS.CLIENTS.complaindDetail}/${id}?complaints=${complaints}`);
  }
  getAdvisorDocuments(advisorId: string) {
    return this.http.get(`${API_END_POINTS.CLIENTS.documents}/${advisorId}`)
  }
  getAdvisorPerformance(advisorId: string) {
    return this.http.get(`${API_END_POINTS.CLIENTS.advisorPerformance}/${advisorId}`)
  }

  freeSubscription(investPackId: string) {
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.free_subscribe}?investPackId=${investPackId}`)
  }

  setRebalanceInstrument(instrument){
    this.rebalanceInstrument.next(instrument)
  }

  getRebalanceInstrument(){
    return this.rebalanceInstrument.asObservable()
  }
  
  getPerformanceConsent(investpackId: any) {
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.performanceConsent}?consentFor=RETURNS_AND_PERFORMANCE_GRAPH_VIEW&investpackId=${investpackId}`)
  }
  acceptPerformanceConsent(data: any) {
    return this.http.post(`${API_END_POINTS.INVESTOR_LONGTERM.performanceConsent}`, data);
  }
  calculateAumInvestment(data:any){
    return this.http.post(API_END_POINTS.AUM_BILLING.calculateInvestment,data)
  }
  additionalInvestment(data:any){
    return this.http.post(API_END_POINTS.AUM_BILLING.additional_payment,data)
  }
  getRebalanceHistory(investpackId:string){
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.newRebalanceHistory}?investPackId=${investpackId}`)
  }
  criticalUpdates(): Observable<any> {
    return this.http.get(API_END_POINTS.INVESTOR_LONGTERM.criticalUpdates);
  }
  getSubscriptionPackDetails(investpackId:string){
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.subscription_details}?investpackId=${investpackId}`)
  }
  sellInstruments(data): Observable<any> {
    return this.http.post(API_END_POINTS.INVESTOR_LONGTERM.sell, data);
  }
  getCouponByInvestId(query: any): Observable<any> {
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.couponById}/${query}`)
  }
  acceptPerformanceConsentForInvestpackList(payload: any) {
    return this.http.post(API_END_POINTS.INVESTOR_LONGTERM.acceptPerformanceConsentForInvestpackList, payload);
  }

  getPerformanceConsentForInvestpackList() {
    return this.http.get(API_END_POINTS.INVESTOR_LONGTERM.getPerformanceConsentForInvestpackList);
  }

  getAumExitFee(investpackId:string){
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.getAumExitFee}?investpackId=${investpackId}`)
  }
  getLastTransaction(investpackId: string) {
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.getLastTransaction}/${investpackId}`);
  }

  downloadFactsheet(investpackId: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.factsheetDownload}/${investpackId}`, {
      observe: 'response',
      responseType: 'blob'
    });
  }

}


export interface InvestPackFilter {
  riskValue?: string,
  isPaid?: string,
  categories?: string,
  investments?: string,
  tags?: string
}